import { createSelector } from 'reselect'
import myLibraryLessonSelector from 'redux/selectors/my_library/my_library_lesson_selector'

const entitySelector = (state, props) => {
	if (props.entityType === 'lesson') {
		return myLibraryLessonSelector(state, props)
	}
	return {}
}

const getShare = state => state.share

const shareLessonSelector = createSelector(
	[getShare, entitySelector],
	(share, entity) => ({
		share,
		entity,
	})
)

export default shareLessonSelector
